<template>
  <div style="margin-top:15px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <!--<el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="所属机构" prop="partyGroupCode" style="margin-right:15px">
              <el-select v-model="form.partyGroupCode" placeholder="请选择机构" clearable style="width: 100%">
                <el-option
                  v-for="item in partyGroup"
                  :key="item.code"
                  :label="item.groupName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>-->

      <el-row>
        <el-form-item label="类型名称" prop="name" style="margin-right:15px">
          <el-input v-model="form.name" placeholder="请输入类型名称" />
        </el-form-item>
        <el-form-item label="系统类型" prop="sysType" style="margin-right:15px">
          <dictElSelect ref="sysTypes" @changeSysType="selectSysType" />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import dictElSelect from '@/views/components/dictElSelect.vue'
export default {
  name: 'CostTypeAdd',
  components: {
    dictElSelect
  },
  data() {
    return {
      form: {
        name: '',
        sysType: '',
        partyGroupCode:'',

      },
      partyGroup:[],

      rules: {
        name: [
          { required: true, message: '请输入类型名称', trigger: 'blur' },

        ],
        sysType: [
          { required: true, message: '请输入系统类型', trigger: 'blur' },

        ],
        partyGroupCode: [
          { required: true, message: '请选择所属机构', trigger: 'blur' }
        ],


      }
    }
  },
  created() {},
  methods: {
    // 选择系统类型
    selectSysType(value) {
      this.form.sysType = value
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form
          request({ url: '/ntocc-basic-api/costType', method: 'post', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => {
            this.$refs['form'].resetFields()
            this.$refs.sysTypes.setSelectValue('')

          })
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
    margin:15px 0 15px 0;
    width: 175px;
    float: right;
}

</style>
